import { render, staticRenderFns } from "./makeMessagesAsRead.vue?vue&type=template&id=ccc69840"
import script from "./makeMessagesAsRead.vue?vue&type=script&lang=js"
export * from "./makeMessagesAsRead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/francescobarbieri/Dev/brain/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ccc69840')) {
      api.createRecord('ccc69840', component.options)
    } else {
      api.reload('ccc69840', component.options)
    }
    module.hot.accept("./makeMessagesAsRead.vue?vue&type=template&id=ccc69840", function () {
      api.rerender('ccc69840', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin-panel/components/admin/messenger/makeMessagesAsRead.vue"
export default component.exports